import { ArrowRightIcon } from "@heroicons/react/solid";
import React from "react";

export default function Navbar() {
  return (
    <header className="bg-black border-b-2 border-red-700 md:sticky top-0 z-10">
      <div className="container mx-auto flex flex-wrap p-5 flex-col md:flex-row items-center">
        <a
          href="#about"
          className="title-font font-medium text-white mb-4 md:mb-0 ml-3 text-xl"
        >
          Christina Delancy
        </a>
        <nav className="md:mr-auto md:ml-4 md:py-1 md:pl-4 md:border-l md:border-silver flex flex-wrap items-center text-base justify-center text-silver">
          <a href="#projects" className="mr-5 hover:text-red-500">
            Past Work
          </a>
          <a href="#skills" className="mr-5 hover:text-red-500">
            Skills
          </a>
        </nav>
        <a
          href="#contact"
          className="inline-flex items-center bg-red-700 text-white border-0 py-1 px-3 focus:outline-none hover:bg-red-600 rounded text-base mt-4 md:mt-0"
        >
          Contact Me
          <ArrowRightIcon className="w-4 h-4 ml-1" />
        </a>
      </div>
    </header>
  );
}



// WEBPACK FOOTER //
// ./src/components/Navbar.js